import React, { useState, useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import './VolunteerTestView.css'
import LoadingScreen from '../components/LoadingScreen'

const VolunteerTestView = () => {
  const { testId } = useParams()
  const history = useHistory()
  const [test, setTest] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    const token = localStorage.getItem('access_token')
    if (!token) {
      history.push('/login')
      return
    }
    fetchTest()
  }, [testId, history])

  const fetchTest = async () => {
    try {
      const token = localStorage.getItem('access_token')
      const response = await fetch(`/api/volunteer/tests/${testId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      if (response.ok) {
        const data = await response.json()
        setTest(data.test)
      } else {
        setError('Failed to load test')
      }
    } catch (err) {
      setError('Network error')
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <LoadingScreen message="Loading Test Details" />
  }

  if (error || !test) {
    return (
      <div className="volunteer-test-view-container">
        <div className="error">{error || 'Test not found'}</div>
        <button onClick={() => history.push('/volunteer/tests')}>Back to Tests</button>
      </div>
    )
  }

  return (
    <div className="volunteer-test-view-container">
      <header className="page-header">
        <h1>{test.title}</h1>
        <button onClick={() => history.push('/volunteer/tests')}>← Back</button>
      </header>

      <main className="test-details">
        <div className="test-info-section">
          <h2>Test Information</h2>
          <p><strong>Description:</strong> {test.description || 'No description'}</p>
          <p><strong>Duration:</strong> {test.duration_minutes} minutes</p>
          <p><strong>Passing Score:</strong> {test.passing_score}%</p>
          <p><strong>Total Questions:</strong> {test.total_questions || 0}</p>
          <p><strong>Total Attempts:</strong> {test.total_attempts || 0}</p>
          <p><strong>Completed Attempts:</strong> {test.completed_attempts || 0}</p>
          <p><strong>Average Score:</strong> {test.average_score || 0}%</p>
        </div>

        {test.questions && test.questions.length > 0 && (
          <div className="questions-section">
            <h2>Questions (Read-Only)</h2>
            {test.questions.map((question, index) => (
              <div key={question.id} className="question-card">
                <h3>Question {index + 1}</h3>
                <p>{question.question_text}</p>
                <div className="options">
                  {question.options.map((option, optIndex) => (
                    <div key={optIndex} className={`option ${optIndex === question.correct_answer ? 'correct' : ''}`}>
                      {String.fromCharCode(65 + optIndex)}. {option}
                      {optIndex === question.correct_answer && <span className="correct-badge">✓ Correct</span>}
                    </div>
                  ))}
                </div>
                <p className="points">Points: {question.points}</p>
              </div>
            ))}
          </div>
        )}

        <div className="actions">
          <button onClick={() => history.push('/volunteer/attempts?test_id=' + testId)}>
            View Attempts
          </button>
        </div>
      </main>
    </div>
  )
}

export default VolunteerTestView

